module.exports = __webpack_public_path__ + "static/media/wood4.ce51839d.jpg";